import { useContext, useEffect, useState } from 'react';
import { KeycloakContext } from '../components/context/KeycloakContext';
import { ContactFormConnector } from '../services/connectors/ContactFormConnector';
import { LoaderContext } from '../components/context/LoaderContext';
import { notifyUserLoggedIn } from '../session-storage';

export function useCustomerData(keycloakCtx: any) {
  const keycloakContext = keycloakCtx || useContext(KeycloakContext);
  const loaderContext = useContext(LoaderContext);
  const [customerData, setCustomerData] = useState<any>(null);

  useEffect(() => {
    // the customer data has been already fetched
    if (customerData) {
      notifyUserLoggedIn(true);
      loaderContext.requestLoaderHide('customer-data');
      return;
    }

    if (!keycloakContext.tokenData) {
      loaderContext.requestLoaderShow('customer-data');
      return;
    }

    // Keycloak is initialized but there is no point in fetching the customer data
    if (keycloakContext.tokenData && !keycloakContext.tokenData.customerId) {
      loaderContext.requestLoaderHide('customer-data');
      notifyUserLoggedIn(false);
      return;
    }

    new ContactFormConnector().getCustomerInfo().then((customerData) => {
      if (loaderContext.isLoaderActive()) {
        const customerId = keycloakContext.tokenData?.customerId;
        setCustomerData({
          ...customerData?.toData(),
          customerId: customerId,
        });
        notifyUserLoggedIn(!!customerId);
      } else {
        console.log('Not setting customer data because the loader is already off.', customerData);
      }
      loaderContext.requestLoaderHide('customer-data');
    });
  }, [keycloakContext]);

  return customerData;
}
